<template>
    <container v-if="property.serviceLevel == 'W'">
        <row>
            <column :lg="8" class="pe-0 pe-md-3">
                <essential-marquis-title :stacked="true" class="mb-5 mb-lg-0" />
            </column>
            <column :lg="16">
                <essential-marquis-list :includeIcons="false"/>
            </column>
        </row>
    </container>
</template>

<script type="text/javascript">
    import EssentialMarquisTitle from '@/components/Content/Public/Properties/EssentialInfo/MarquisTitle.vue';
    import EssentialMarquisList from '@/components/Content/Public/Properties/EssentialInfo/MarquisList.vue';

    import ApiObject from '@/classes/ApiObject.js';
    import CommonComponents from '@/components/Common.vue';


    export default {
        components: {
            EssentialMarquisTitle,
            EssentialMarquisList,
            ...CommonComponents,
        },

        props: {
            property: {
                type: ApiObject,
                required: true,
            },
        },
    };

</script>
